import React from 'react';

import { camelize } from '@vimeo/core/libs/camelize';
import { translate } from '@vimeo/i18n-runtime';
import { Button } from '@vimeo/iris/components';

import { FetchBtnWidth } from '../Styles';
import { FileDownload } from '../types';

type Props = {
  file: FileDownload;
  fetchFile: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isReview?: boolean;
};

const DownloadPanelDownloadButton = ({ file, isReview = false, fetchFile }: Props) => {
  if (file?.isCold) {
    const fetchButtonClassList = `iris_btn-outline--downplay iris_btn--sm`;
    return (
      <FetchBtnWidth type="button" className={fetchButtonClassList} onClick={fetchFile}>
        {translate('Fetch')}
      </FetchBtnWidth>
    );
  }

  const fileName = camelize(file.publicName);
  const fatalAttraction = `container:${
    isReview ? 'video_review' : 'clip'
  }|component:modal|keyword:download_${fileName}`;

  return (
    <a data-fatal-attraction={fatalAttraction} href={file.link}>
      <Button format="secondary" size="sm" element="span">
        {translate('Download')}
      </Button>
    </a>
  );
};

export default DownloadPanelDownloadButton;
